import {
  Residence,
  ResidenceActionType,
} from 'src/components/Loan/Application/Sections/BorrowerInfo/Inputs/Residence/store/types';

type ResidenceStore = Residence[];

const defaultState: ResidenceStore = [];

const reducer = (
  state: ResidenceStore = defaultState,
  { type, data }: { type: ResidenceActionType; data: any },
): ResidenceStore => {
  switch (type) {
    // @ts-ignore
    case 'clear_loan_data':
      return defaultState;
    case ResidenceActionType.SET: {
      const items = [...state];
      for (const item of data) {
        const matchIndex = state.findIndex((x) => x.id === item.id);
        if (matchIndex > -1) {
          items.splice(matchIndex, 1, {
            ...items[matchIndex],
            ...item,
          });
        } else {
          items.push(item);
        }
      }
      return items;
    }
    case ResidenceActionType.UPDATE: {
      const matchIndex = state.findIndex((x) => x.id === data.id);
      const items = [...state];

      items.splice(matchIndex, 1, {
        ...items[matchIndex],
        ...data,
      });
      return items;
    }
    case ResidenceActionType.ADD: {
      const items = [...state, data];
      return items;
    }
    case ResidenceActionType.DELETE: {
      const matchIndex = state.findIndex((x) => x.id === data);
      const items = [...state];
      items.splice(matchIndex, 1);
      return items;
    }
    default:
      return state;
  }
};

export default reducer;
